import script from "./contact.vue?vue&type=script&setup=true&lang=js"
export * from "./contact.vue?vue&type=script&setup=true&lang=js"

import "./contact.vue?vue&type=style&index=0&id=7d57dd2e&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\Other\\EventMaster\\Dataleading3.0\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d57dd2e"]])

export default __exports__